'use strict';

var markers = [];
var stores = [];
var scaledSize;
var iconHover;

function initIconHover() {
    window.isMobile ? scaledSize = new google.maps.Size(35, 50) : scaledSize = new google.maps.Size(45, 70);
    iconHover = {
        url: $('#map').data('urlmarker'),
        scaledSize: scaledSize
    };
}

window.addEventListener('DOMContentLoaded', initIconHover);
if (typeof google !== 'undefined') {
    initIconHover();
}

// boutiques sono gli ogetti store del B.M
// singleBoutique è un boleano che ci indica se siamo sul singolo store o nella lista
// country code
function createMap(boutiquesResult, singleBoutique, countryCode) {
    var center = { lat: 43.082654, lng: 12.274691 };
    var map;
    var streetView;
    stores = [];
    var boutiques = [];
    if (boutiquesResult) boutiques = boutiquesResult;
    if (!singleBoutique) {
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 4,
            center: center,
            styles: [{ featureType: 'administrative', elementType: 'all', stylers: [{ saturation: '-100' }] }, { featureType: 'administrative.province', elementType: 'all', stylers: [{ visibility: 'off' }] }, { featureType: 'landscape', elementType: 'all', stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: 'on' }] }, { featureType: 'poi', elementType: 'all', stylers: [{ saturation: -100 }, { lightness: '50' }, { visibility: 'off' }] }, { featureType: 'road', elementType: 'all', stylers: [{ saturation: '-100' }] }, { featureType: 'road.highway', elementType: 'all', stylers: [{ visibility: 'simplified' }] }, { featureType: 'road.arterial', elementType: 'all', stylers: [{ lightness: '30' }] }, { featureType: 'road.local', elementType: 'all', stylers: [{ lightness: '40' }] }, { featureType: 'transit', elementType: 'all', stylers: [{ saturation: -100 }, { visibility: 'simplified' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ hue: '#ffff00' }, { lightness: -15 }, { saturation: -97 }] }, { featureType: 'water', elementType: 'labels', stylers: [{ lightness: -25 }, { saturation: -100 }] }]
        });
        var geocoder = new google.maps.Geocoder();
        var location, bounds;
        geocoder.geocode({ componentRestrictions: { country: countryCode } }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                location = results[0].geometry.location;
                bounds = results[0].geometry.bounds;
                map.setCenter(location);
                map.fitBounds(bounds);
            }
        });
    } else {
        center = { lat: boutiques[0].markers.lat, lng: boutiques[0].markers.long };
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 18,
            center: center,
            styles: [{ featureType: 'administrative', elementType: 'all', stylers: [{ saturation: '-100' }] }, { featureType: 'administrative.province', elementType: 'all', stylers: [{ visibility: 'off' }] }, { featureType: 'landscape', elementType: 'all', stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: 'on' }] }, { featureType: 'poi', elementType: 'all', stylers: [{ saturation: -100 }, { lightness: '50' }, { visibility: 'off' }] }, { featureType: 'road', elementType: 'all', stylers: [{ saturation: '-100' }] }, { featureType: 'road.highway', elementType: 'all', stylers: [{ visibility: 'simplified' }] }, { featureType: 'road.arterial', elementType: 'all', stylers: [{ lightness: '30' }] }, { featureType: 'road.local', elementType: 'all', stylers: [{ lightness: '40' }] }, { featureType: 'transit', elementType: 'all', stylers: [{ saturation: -100 }, { visibility: 'simplified' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ hue: '#ffff00' }, { lightness: -15 }, { saturation: -97 }] }, { featureType: 'water', elementType: 'labels', stylers: [{ lightness: -25 }, { saturation: -100 }] }]
        });
    }
    for (var i = 0; i < boutiques.length; i++) {
        var latlng = { lat: boutiques[i].markers.lat, lng: boutiques[i].markers.long };
        var storeLocation = {
            ID: boutiques[i].ID,
            position: latlng,
            city: boutiques[i].city,
            image: boutiques[i].boutiqueImage,
            strokeClose: boutiques[i].strokeClose,
            address: boutiques[i].address1,
            url: boutiques[i].urlSingleBoutique,
            stateCode: boutiques[i].stateCode,
            postalCode: boutiques[i].postalCode,
            country: boutiques[i].country,
            phone: boutiques[i].phone,
            storeHours: boutiques[i].storeHours,
            showMore: boutiques[i].more,
            bookAppointmentLink: boutiques[i].bookAppointmentLink || false,
            bookLabel: boutiques[i].bookLabel || false,
            sartoriaName: boutiques[i].sartoriaName ? boutiques[i].sartoriaName : null
        };
        stores.push(storeLocation);
    }
    if (!window.isMobile) {
        setMarkers(map, singleBoutique, boutiques);
    } else {
        setMarkersMobile(map, singleBoutique, boutiques);
    }
    // accessibility: disable compass button
    streetView = map.getStreetView();
    google.maps.event.addListenerOnce(streetView, 'visible_changed', function() {
        if (streetView.getVisible()) {
            const mapElement = document.getElementById('map');
            const observer = new MutationObserver((mList, ob) => {
                for (var i = 0; i < mList.length; i++) {
                    if (mList[i].target.getAttribute('class') === 'gm-compass') {
                        // compass element added to the DOM
                        ob.disconnect();
                        mList[i].target.setAttribute('aria-label', $('#js-gmaps-compass-label').val());
                        mList[i].target.querySelector('img').setAttribute('alt', $('#js-gmaps-compass-label').val());
                        var backBtn = $('div.gm-iv-back-icon-background');
                        backBtn.attr('aria-label', $('.cc-close-button > button').attr('aria-label'));
                        backBtn.replaceWith(backBtn[0].outerHTML.replace(/div/g, 'button'));
                        break;
                    }
                }
            });
            observer.observe(mapElement, { attributes: false, childList: true, subtree: true });
        }
    });
}
function setMarkers(map, singleBoutique, boutiques) {
    // Adds markers to the map.
    cleanMarker();
    for (var i = 0; i < stores.length; ++i) {
        var store = stores[i];
        var marker = new google.maps.Marker({
            ID: store.ID,
            position: store.position,
            map: map,
            icon: iconHover,
            city: store.city,
            image: store.image[0],
            strokeClose: store.strokeClose
        });
        var infowindow = new google.maps.InfoWindow({
            content: infowindowContent(store, singleBoutique)
        });
        marker.infobox = infowindow;
        markers.push(marker);

        google.maps.event.addListener(marker, 'click', (function (marker, i) {
            return function () {
                // remove class active
                $('.cc-single-boutiques-result').removeClass('cc-active-live-search');

                // Close all other infoboxes
                for (var j = 0; j < markers.length; j++) {
                    if (i !== j) markers[j].infobox.close(map);
                }
                $('#map div[role="button"]').attr('aria-expanded','false');

                // Open correct info box and toggle aria-expanded
                if (isInfoWindowOpen(markers[i].infobox)) {
                    markers[i].infobox.close(map, markers[i]);
                    $('.js-boutique-' + markers[i].ID).removeClass('cc-active-live-search');
                    $('#map div[role="button"]').eq(i).attr('aria-expanded', 'false');
                } else {
                    markers[i].infobox.open(map, markers[i]);
                    $('.js-boutique-' + markers[i].ID).addClass('cc-active-live-search');
                    $('#map div[role="button"]').eq(i).attr('aria-expanded', 'true');
                }
            };
        })(marker, i));
        // close infowindow when tap in to map
        google.maps.event.addListener(map, 'click', (function(map, i) {
            return function() {
                markers[i].infobox.close(map);
                $('.cc-single-boutiques-result').removeClass('cc-active-live-search');
                $('#map div[role="button"]').eq(i).attr('aria-expanded','false');
            };
        })(map, i));

        // close infowindow when click on x
        google.maps.event.addListener(infowindow, 'domready', (function(infowindow, i) {
            return function() {
                $('.cc-boutiques-close').on('click', function () {
                    markers[i].infobox.close(map);
                    $('.cc-single-boutiques-result').removeClass('cc-active-live-search');
                    $('#map div[role="button"]').eq(i).attr('aria-expanded', 'false');
                });
            };
        })(infowindow, i));
    }

    // accessibility for google maps
    google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
        onMapLoaded(boutiques); // timeout breaks js when user change filter fast
    });
}

function onMapLoaded(boutiques) {
    // add alt text to marker images
    $('div#map div[role="button"] > img').attr('alt', $('#js-gmaps-marker-label').val());

    // fix fullscreen button
    $('.gm-fullscreen-control').removeAttr('title').attr({
        'aria-label': $('#js-gmaps-fullscreen-label').val(),
        'aria-pressed': 'false'
    });
    $(document).on('click', '#map .gm-fullscreen-control', function() {
        var pressed = $(this).attr('aria-pressed');
        $(this).attr('aria-pressed', pressed === 'false' ? 'true' : 'false');
    });

    // hide second keyboard shortcuts button
    $('.gm-style button[title="Keyboard shortcuts"]')
        .filter(function() { return $(this).width() === 0; })
        .attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        });

    // add boutique names labels to markers
    $('#map div[role="button"]').each((i, btn) => {
        $(btn).attr({
            'aria-expanded': 'false',
            'aria-label': boutiques[i].name
        });
    });

    // close the keyboard modal by pressing ESC
    $(document).on('keyup', function(e) {
        if (e.key === 'Escape') {
            var $shortcutsDialog = $('.uNGBb-dialog-view--content:visible');
            if ($shortcutsDialog.length) {
                $shortcutsDialog.hide().parent().hide();
            } else {
                // close boutique info dialog
                $('#map div[role="button"][aria-expanded="true"]').attr('aria-expanded', 'false');
                $('.gm-style-iw.gm-style-iw-c[role="dialog"]:visible').find('#js-close-infowindow').trigger('click');
            }
        }
    });

    // make pegman button reachable with keyboard
    $('#map .gm-svpc').attr('tabindex', '0');

    // set aria attributes for keyboard shortcuts dialog
    $(document).one('click', '.gmnoprint button[title="Keyboard shortcuts"]', () => {
        const dialog = $('.uNGBb-dialog-view--content');
        $(dialog).find('h2:first-of-type').attr('id', 'keyboard_shortcuts_title');
        $(dialog).attr({
            'role': 'dialog',
            'aria-modal': 'true',
            'aria-labelledby': 'keyboard_shortcuts_title'
        });
    });

    // remove inactive div from focus sequence
    $('#map [tabindex=0][aria-label="Map"]').removeAttr('tabindex');
}

function isInfoWindowOpen(infoWindow) {
    var map = infoWindow.getMap();
    return (map !== null && typeof map !== 'undefined');
}

function setMarkersMobile(map, singleBoutique, boutiques) {
    cleanMarker();
    for (var i = 0; i < stores.length; ++i) {
        var store = stores[i];
        var marker = new google.maps.Marker({
            ID: store.ID,
            position: store.position,
            map: map,
            icon: iconHover,
            city: store.city,
            image: store.boutiqueImage,
            strokeClose: store.strokeClose,
            url: store.url
        });
        markers.push(marker);
        if (!singleBoutique) {
            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    window.location.href = markers[i].url;
                };
            })(marker, i));
        }
    }

    // accessibility: add labels to markers
    google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
        $('div#map div[role="button"] > img').attr({ 'aria-hidden': 'true', 'focusable': 'false' });
        $('#map div[role="button"]').each((i, btn)=> {
            $(btn).attr('aria-label', boutiques[i].name);
        });
    });
}

$(document).on('click', '.js-active-search', function () {
    var boutiqueid = this.dataset.boutiqueid;
    for (var j = 0; j < markers.length; j++) {
        if (markers[j].ID === boutiqueid) {
            markers[j].infobox.open(map, markers[j]);
        } else {
            markers[j].infobox.close(map, markers[j]);
        }
    }
});

function cleanMarker() {
    var length = markers.length;

    for (var i = 0; i < length; i++) {
        markers[i].setMap(null);
    }
    for (var j = 0; j < length; j++) {
        markers.pop();
    }
}

function infowindowContent(data, singleBoutique) {
    var closeLabel = $('#js-close-label').val();
    var contentString;
    if (singleBoutique) {
        contentString = '<div class="cc-signle-boutiques-google-markers">' +
            '<div class="cc-single-google-header">' +
            '<h2 class="cc-text-title cc-marker-padding heading-as-span">' + (data.sartoriaName ? data.sartoriaName : data.city) + '</h2>' +
            '<button class="cc-boutiques-close" id="js-close-infowindow" aria-label="'+closeLabel+'">' +
            '<svg class="cc-icon" aria-hidden="true" focusable="false">' +
            '<use xlink:href="' + data.strokeClose + '"></use></svg>' +
            '</button>' +
            '</div>' +
            '<div class="container cc-marker-padding-top">' +
            '<div class="row">' +
            '<div class="col-12 cc-clean-padding">' +
            '<img class="cc-boutiqus-images" src="' + data.image[0] + '" alt="boutiques-pictures">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    }
    if (singleBoutique && window.isTablet) {
        var rightarrow = $('.cc-images-single-boutiques').data('arrowdx');
        var leftarrow = $('.cc-images-single-boutiques').data('arrowsx');
        // va implementato lo slider se la boutique ha più di un immagine
        contentString = '<div class="cc-signle-boutiques-google-markers">' +
            '<div class="cc-single-google-header">' +
            '<h2 class="cc-text-title cc-marker-padding heading-as-span">' + (data.sartoriaName ? data.sartoriaName : data.city) + '</h2>' +
            '<button class="cc-boutiques-close" id="js-close-infowindow" aria-label="'+closeLabel+'">' +
            '<svg class="cc-icon" aria-hidden="true" focusable="false">' +
            '<use xlink:href="' + data.strokeClose + '"></use></svg>' +
            '</button>' +
            '</div>' +
            '<div class="container cc-marker-padding-top">' +
            '<div class="row">' +
            '<div class="col-12 cc-clean-padding">' +
            '<img class="cc-boutiqus-images" src="' + data.image[0] + '" alt="boutiques-pictures">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    }
    if (!singleBoutique && !window.isMobile) {
        var showMore = '<a href="' + data.url + '" class="cc-boutique-link" aria-label="' + data.showMore + ' ' + (data.sartoriaName || data.city) + '">' + data.showMore + '</a>';
        var appointmentLink = '<a href="' + data.bookAppointmentLink + '" class="cc-boutique-link-right">' + data.bookLabel + '</a>';
        if (data.bookAppointmentLink) {
            appointmentLink = '<a href="' + data.bookAppointmentLink + '" class="cc-boutique-link-right">' + data.bookLabel + '</a>';
        } else {
            appointmentLink = '';
        }
        contentString = '<div class="cc-google-marker">' +
        '<div class="cc-google-header">' +
        '<h2 class="cc-text-title cc-marker-padding heading-as-span">' + (data.sartoriaName ? data.sartoriaName : data.city) + '</h2>' +
        '<button class="cc-boutiques-close" id="js-close-infowindow" aria-label="'+closeLabel+'">' +
        '<svg class="cc-icon" aria-hidden="true" focusable="false">' +
        '<use xlink:href="' + data.strokeClose + '"></use></svg>' +
        '</button>' +
        '</div>' +
        '<div class="cc-marker-padding-top">' +
        '<div class="row">' +
        '<div class="col-12 col-sm-6">' +
        '<div class="cc-content-img">' +
        '<img class="cc-boutiqus-images" src="' + data.image[0] + '" alt="boutiques-pictures">' +
        '</div>' +
        '</div>' +
        '<div class="col-12 col-sm-6 cc-marker-details">' +
        '<p class="cc-text-medium">' + data.address + ', ' +
        '<p class="cc-text-medium">' + data.stateCode + ' ' + data.postalCode + ', ' + data.country + '</p>' +
        '<p class="cc-text-phone">' + data.phone + '</p>' +
        '<p class="cc-text-hours">' + data.storeHours + '</p>' + showMore + appointmentLink +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    }
    return contentString;
}

module.exports = {
    createMap: createMap
};
